import currency from "currency.js";

export const Rupees = (value: currency.Any) => currency(value, { symbol: '₹' });
